import React from 'react';
import { BasicFieldCheckboxTemplate } from 'themes/components';

function BasicFieldCheckbox(props) {
    return <BasicFieldCheckboxTemplate {...props} />
}

export default BasicFieldCheckbox;